/**
 * Porovná dvě verze. Kontroluje, zda základní verze (první parametr) je nižší nebo stejná jako zadaná porovnávaná verze (druhý parametr).
 * Pokud je základní verze undefined, tak vrací vždy false.
 * @example "15.01" je menší nebo rovna "20.00"; "15.01" není menší nebo rovna "14.05"
 * @param baseVersion Základní verze u které se kontroluje, zda je nižší nebo rovna. Při undefined vrací false.
 * @param comparedVersion Verze, proti které probíhá kontrola.
 */
export const isVersionOlderOrEqual = (baseVersion: string | undefined, comparedVersion: string): boolean => {
    if (baseVersion == undefined)
        return false;

    if (!baseVersion.match(/\d{2}\.\d{2}/))
        throw Error(`Current version '${baseVersion}' has invalid format. Required format is 'XX.YY'.`);
    if (!comparedVersion || !comparedVersion.match(/\d{2}\.\d{2}/))
        throw Error(`Compared version '${comparedVersion}' has invalid format. Required format is 'XX.YY'.`);

    const parse = (version: string) => version.split(".").map(part => part.startsWith("0") ? part.substr(1) : part).map(part => parseInt(part));

    const [baseVersionMajor, baseVersionMinor] = parse(baseVersion);
    const [comparedVersionMajor, comparedVersionMinor] = parse(comparedVersion);

    // rozdíl je už v major verzi
    if (baseVersionMajor < comparedVersionMajor)
        return true;

    // pokud jsou major verze (první dvojčíslí) stejné, tak se porovnávají ještě minor verze (druhé dvojčíslí)
    if (baseVersionMajor === comparedVersionMajor)
        return baseVersionMinor <= comparedVersionMinor;

    return false;
};
